import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_TYPOGRAPHY_BODY } from '../../../../styles/typography/typography';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_GREY_700 } from '../../../../styles/colors/colors';
export var resultsPerPageSelectTheme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {}
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          marginTop: '5px',
          borderRadius: '8px',
          ul: {
            paddingTop: '4px',
            paddingBottom: '4px',
            maxHeight: '208px',
            li: {
              marginBottom: '4px'
            }
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
          padding: '4px 8px',
          position: 'relative',
          '.MuiOutlinedInput-input.MuiSelect-outlined.MuiSelect-select': {
            padding: '0 28px 0 0'
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: "1px solid ".concat(PROMETHEAN_NEUTRAL_GREY_700)
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: "2px solid ".concat(PROMETHEAN_BLUE)
          },
          '&.Mui-focused': {
            '&.EmbersBasicSelect-focused-by-click .MuiOutlinedInput-notchedOutline': {
              border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
            }
          },
          '.icon-expand-more': {
            cursor: 'pointer',
            position: 'absolute',
            right: '8px',
            pointerEvents: 'none',
            '&.is-open': {
              transform: 'rotate(180deg)'
            }
          }
        })
      }
    }
  }
});